import styled from 'styled-components';

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;

  flex: 1;

  font-size: 16px;
  color: ${({ theme }) => theme.colors.gray[900]};

  min-width: 490px;
  height: 436px;
  padding: 16px;

  background-color: ${({ theme }) => theme.colors.white};
  box-shadow: ${({ theme }) => theme.shadow.default};
  border-radius: 8px;

  > h3 {
    font-size: 2vh;
    font-weight: 600;
    margin-bottom: 16px;
  }

  > section {
    width: 100%;
    height: 80%;
    display: flex;
    justify-content: center;
    gap: 24px;

    .chart {
      width: 60%;
      height: 92%;
    }

    .legendContainer {
      display: flex;
      flex-direction: column;
      justify-content: center;
      max-height: 98%;

      h3 {
        font-weight: 600;
        font-size: 2vh;
        margin-bottom: 16px;
      }

      .lines {
        display: flex;
        flex-direction: column;
        flex-wrap: wrap;
        height: fit-content;
        max-height: 100%;
        gap: 8px;

        .line {
          display: flex;
          align-items: center;
          gap: 8px;
          max-height: 32px;

          div {
            width: 30px;
            height: 6px;
            border-radius: 3px;
          }

          p {
            font-weight: 400;
            color: ${({ theme }) => theme.colors.gray[600]};
            position: relative;
          }
        }
      }
    }
  }
`;
